import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
/**
 * Handles keyboard navigation in dropdown lists.
 * Adapted from flamarkt/backoffice, modernized to use event.key instead of keyCodes.
 */
export default class KeyboardNavigatable {
  constructor() {
    _defineProperty(this, "callbacks", new Map());
    _defineProperty(this, "whenCallback", () => true);
  }
  onUp(callback) {
    this.callbacks.set('ArrowUp', e => {
      e.preventDefault();
      callback(e);
    });
    return this;
  }
  onDown(callback) {
    this.callbacks.set('ArrowDown', e => {
      e.preventDefault();
      callback(e);
    });
    return this;
  }
  onSelect(callback, ignoreTabPress) {
    if (ignoreTabPress === void 0) {
      ignoreTabPress = false;
    }
    const handler = e => {
      e.preventDefault();
      callback(e);
    };
    if (!ignoreTabPress) this.callbacks.set('Tab', handler);
    this.callbacks.set('Enter', handler);
    return this;
  }
  onRemove(callback) {
    this.callbacks.set('Backspace', e => {
      if (e.target.value === '') {
        e.preventDefault();
        callback(e);
      }
    });
    return this;
  }
  when(callback) {
    this.whenCallback = callback;
    return this;
  }
  navigate(event) {
    if (this.whenCallback(event) === false) {
      return;
    }
    const handler = this.callbacks.get(event.key);
    if (handler) {
      handler(event);
    }
  }
}
flarum.reg.add('ekumanov-post-search', 'forum/utils/KeyboardNavigatable', KeyboardNavigatable);